import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import LearningImage from "../../assets/images/learning.svg";
import StudentConnection from "../../assets/images/student.svg";
import SecureDataImg from "../../assets/images/securedata.svg";
const ServiceSection = () => {
  return (
    <div>
      <div className="section_padding">
        <Container>
          <Row>
            <Col md={12}>
              <div className="text-center mb-5">
                <h2 className="section-heading">Services You Get</h2>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center mt-4">
            <Col md={6} sm={12}>
              <h3 className="mb-4">Simplify teaching and learning</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                maximus eu erat ac iaculis. Phasellus vel magna tincidunt,
                viverra nunc nec, tincidunt felis.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                maximus eu erat ac iaculis. Phasellus vel magna tincidunt,
                viverra nunc nec, tincidunt felis.
              </p>
            </Col>
            <Col md={6} sm={12}>
              <Image src={LearningImage} className="img-fluid" />
            </Col>
          </Row>
          <Row className="align-items-center mt-4">
            <Col md={6} sm={12}>
              <Image src={StudentConnection} className="img-fluid" />
            </Col>
            <Col md={6} sm={12}>
              <h3 className="mb-4">Student Connection Strengthen</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                maximus eu erat ac iaculis. Phasellus vel magna tincidunt,
                viverra nunc nec, tincidunt felis.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                maximus eu erat ac iaculis. Phasellus vel magna tincidunt,
                viverra nunc nec, tincidunt felis.
              </p>
            </Col>
          </Row>
          <Row className="align-items-center mt-4">
            <Col md={6} sm={12}>
              <h3 className="mb-4"> Secure your data</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                maximus eu erat ac iaculis. Phasellus vel magna tincidunt,
                viverra nunc nec, tincidunt felis.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                maximus eu erat ac iaculis. Phasellus vel magna tincidunt,
                viverra nunc nec, tincidunt felis.
              </p>
            </Col>
            <Col md={6} sm={12}>
              <Image src={SecureDataImg} className="img-fluid" />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default ServiceSection;
